import { IPaymentMethod, PaymentMethodTypeEnum } from '~/models';

export const PENDING_PAYMENT_STATUS = 'pending';

export const isPendingBankPayment = (payment?: Partial<IPaymentMethod> | null) =>
  payment?.type === PaymentMethodTypeEnum.BankAccount &&
  payment?.status === PENDING_PAYMENT_STATUS;
